// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Tab.module.scss  */
.Tab-module-Root_Sez {
  position: relative;
  z-index: 1;
  display: flex;
  flex-grow: 0;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin: 0;
  padding: 0 30px;
  font-family: var(--title-font-family);
  font-size: var(--tabs-tab-font-size);
  font-weight: var(--tabs-tab-font-weight);
  font-style: normal;
  line-height: var(--tabs-tab-line-height);
  cursor: pointer;
  color: var(--tabs-default-font-color);
  border: none;
  background: none; }

.Tab-module-Disabled_1DD {
  cursor: not-allowed;
  color: var(--tabs-default-disabled-font-color); }

.Tab-module-SelectedDefault_3PN {
  color: var(--tabs-selected-default-font-color); }

.Tab-module-SelectedDefaultDisabled_2X1 {
  color: var(--tabs-selected-default-disabled-font-color); }

.Tab-module-SelectedColourful_35P {
  color: var(--tabs-selected-colourful-font-color); }

.Tab-module-SelectedColourfulDisabled_36k {
  color: var(--tabs-selected-colourful-disabled-font-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Tabs/Tab/Tab.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,qCAAqC;EACrC,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,8CAA8C,EAAE;;AAElD;EACE,8CAA8C,EAAE;;AAElD;EACE,uDAAuD,EAAE;;AAE3D;EACE,gDAAgD,EAAE;;AAEpD;EACE,yDAAyD,EAAE","sourcesContent":["/*  imported from Tab.module.scss  */\n.Tab-module-Root_Sez {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-grow: 0;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 30px;\n  font-family: var(--title-font-family);\n  font-size: var(--tabs-tab-font-size);\n  font-weight: var(--tabs-tab-font-weight);\n  font-style: normal;\n  line-height: var(--tabs-tab-line-height);\n  cursor: pointer;\n  color: var(--tabs-default-font-color);\n  border: none;\n  background: none; }\n\n.Tab-module-Disabled_1DD {\n  cursor: not-allowed;\n  color: var(--tabs-default-disabled-font-color); }\n\n.Tab-module-SelectedDefault_3PN {\n  color: var(--tabs-selected-default-font-color); }\n\n.Tab-module-SelectedDefaultDisabled_2X1 {\n  color: var(--tabs-selected-default-disabled-font-color); }\n\n.Tab-module-SelectedColourful_35P {\n  color: var(--tabs-selected-colourful-font-color); }\n\n.Tab-module-SelectedColourfulDisabled_36k {\n  color: var(--tabs-selected-colourful-disabled-font-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
